import script from "./DraftHistoricProjectComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./DraftHistoricProjectComponent.vue?vue&type=script&lang=ts&setup=true"

import "./DraftHistoricProjectComponent.vue?vue&type=style&index=0&id=1e26f5ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e26f5ce"]])

export default __exports__